import React from "react";
import { HStack, Box, Text } from "@chakra-ui/react";
import { JOURNALIST_STATUS } from "@root/constants";

const JournalistStatusBadge = ({
  status,
  isVerified,
  t,
}: {
  status: number;
  isVerified?: boolean;
  t: any;
}) => {
  // The applicant still has an outstanding email OTP. Show that instead of the
  // approval status — the request cannot be approved until they verify, and
  // without this the row is indistinguishable from a normal pending request.
  if (isVerified === false) {
    return (
      <HStack
        bg="#FFFAEB"
        width="fit-content"
        px="8px"
        pt="2px"
        fontWeight="500"
        fontSize="12px"
        borderRadius="100px"
      >
        <Box boxSize="6px" borderRadius="full" bg="#B54708" />
        <Text color="#B54708">{t("journalistRequests.emailNotVerified")}</Text>
      </HStack>
    );
  }

  if (status === JOURNALIST_STATUS.ACCEPTED) {
    return (
      <HStack
        bg="#ECFDF3"
        width="fit-content"
        px="8px"
        pt="2px"
        fontWeight="500"
        fontSize="12px"
        borderRadius="100px"
      >
        <Box boxSize="6px" borderRadius="full" bg="#027A48" />
        <Text color="#027A48">{t("journalistRequests.accepted")}</Text>
      </HStack>
    );
  } else if (status === JOURNALIST_STATUS.REJECTED) {
    return (
      <HStack
        bg="#FEF3F2"
        width="fit-content"
        px="8px"
        pt="2px"
        fontWeight="500"
        fontSize="12px"
        borderRadius="100px"
      >
        <Box boxSize="6px" borderRadius="full" bg="#B42318" />
        <Text color="#B42318">{t("journalistRequests.rejected")}</Text>
      </HStack>
    );
  } else if (status === JOURNALIST_STATUS.PENDING) {
    return (
      <HStack
        bg="#F8FAFC"
        width="fit-content"
        px="8px"
        pt="2px"
        fontWeight="500"
        fontSize="12px"
        borderRadius="100px"
      >
        <Box boxSize="6px" borderRadius="full" bg="#A3AED0" />
        <Text color="#667085">{t("journalistRequests.pending")}</Text>
      </HStack>
    );
  } else {
    return null;
  }
};

export default JournalistStatusBadge;
